export default __webpack_public_path__ + "static/media/pic3.32da8d1c.jpg";